module.exports = __webpack_public_path__ + "static/media/19ESCAP13.7a2de90a.jpg";